import deliveryTruck from './assets/sprites/delivery-truck.svg';
import deliveryBox from './assets/sprites/delivery-box.svg';
import deliveryPhone from './assets/sprites/delivery-phone.svg';
import deliveryComment from './assets/sprites/delivery-comment.svg';
import { DeliveryInfo } from './InformationTables/DeliveryInfo';
import { DeliveryItemsInfo } from './InformationTables/ItemsInfo';
import { ContactInfo } from './InformationTables/ContactInfo';
import { Order } from '../../../types/interfaces';
import { TabsWithIcons } from './components/TabsWithIcons';
import { TabsBox } from './components/TabsBox';

interface IProps {
  order: Order;
}

/**
 * Раскрывающаяся карточка заказа — табы.
 *
 * Возвращаемся к табам (стэк всех секций сразу был слишком высоким).
 * Главное, что фиксим теперь — «дёрганье» строки при переключении:
 * раньше у каждой вкладки была своя высота (товары: длинная таблица,
 * комментарий: 1 строка), и табле прыгал на 200-300px. Решение —
 * фиксированный `min-h` на контейнере вкладок (см. TabsWithIcons).
 * Само переключение вкладок остаётся мгновенным, но строка таблицы
 * больше не «дышит».
 */
export const OrderCardExpanded = ({ order }: IProps) => {
  return (
    <div >
      <TabsWithIcons>
        <TabsBox title="Информация о доставке" icon={deliveryTruck}>
          <DeliveryInfo order={order} />
        </TabsBox>
        <TabsBox title="Информация о товаре" icon={deliveryBox}>
          <DeliveryItemsInfo order={order} />
        </TabsBox>
        <TabsBox title="Контактная информация" icon={deliveryPhone}>
          <ContactInfo order={order} />
        </TabsBox>
        <TabsBox title="Комментарий" icon={deliveryComment}>
          {order.comment ? (
            <p className="text-sm text-[#2d2c2c] whitespace-pre-wrap break-words p-3">
              {order.comment}
            </p>
          ) : (
            <p className="text-sm text-gray-400 p-3">Комментарий отсутствует</p>
          )}
        </TabsBox>
      </TabsWithIcons>
    </div>
  );
};
